<template>
  <div>
    <v-layout row wrap>
      <v-flex grow>
        <h2 class="headline pb-3">Expenses & Fees</h2>
      </v-flex>
      <v-flex shrink>
        <v-btn color="primary" @click.stop="addFees()">
          <v-icon>add</v-icon>
          Add
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-list two-line subheader>
          <template v-for="(fee, index) in fees">
            <v-list-tile :key="fee.id" avatar @click.stop="setSelectedFee(fee.id)">
              <v-list-tile-avatar>
                <v-icon v-if="fee.state === 99" color="secondry">pending</v-icon>
                <v-icon v-if="fee.state === 0" color="error">warning</v-icon>
                <v-icon v-if="fee.state === 1" color="green">done</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ fee.fee_type ? fee.fee_type.fee_name : '' }}
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  {{ fee.fee_date | moment('D/MM/YYYY') }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                {{ '$' + fee.fee }}
              </v-list-tile-action>
            </v-list-tile>
            <v-divider :key="index"></v-divider>
          </template>
        </v-list>
      </v-flex>
    </v-layout>
    <FeeInfo v-if="selectedFee" :selected-fee.sync="selectedFee" />
  </div>
</template>
<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import FeeInfo from '@/components/houselist/details/FeeInfo'

export default {
  name: 'DetailsFee',
  components: { FeeInfo },
  data() {
    return {
      selectedFee: ''
    }
  },
  computed: {
    ...mapGetters({
      fees: 'HouseList/Fees/get',
      selectedHouse: 'HouseList/getSelectedHouse',
    }),
  },
  methods: {
    ...mapActions({
      add: 'HouseList/Fees/add',
    }),
    async addFees() {
      const fee = {
        id: '',
        house_id: this.selectedHouse.id,
        payment_id: '',
        pay_id: '',
        fee: '',
        fee_date: moment().format('YYYY-MM-DD'),
        fee_type_id: '',
        fee_comment: '',
        fee_gst_status: '',
        fee_real: '',
        fee_gst: '',
        state: 0,
        files: [],
      }

      const feeId = await this.add(fee)
      this.setSelectedFee(feeId)
    },
    setSelectedFee(id) {
      this.selectedFee = id
    }
  },
}
</script>
